import palette from '../palette';
import {GRID_TABLE_SELECTED_ROW} from '../../style/variable';

export default {
  root: {
    '&$selected': {
      backgroundColor: palette.background.default
    },
    '&:hover': {
      backgroundColor: `${GRID_TABLE_SELECTED_ROW} !important`
    }
  }
};
